import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["source", "button"];

  copy() {
    const text = this.sourceTarget.textContent.trim();
    navigator.clipboard.writeText(text).then(() => this.flashCopied());
  }

  flashCopied() {
    if (!this.hasButtonTarget) return;
    const original = this.buttonTarget.innerHTML;
    this.buttonTarget.textContent = "Copied!";
    this.buttonTarget.disabled = true;
    setTimeout(() => {
      this.buttonTarget.innerHTML = original;
      this.buttonTarget.disabled = false;
    }, 1500);
  }
}
